module.exports = __webpack_public_path__ + "static/media/inspiration.1aa0f1c1.png";